/**
 * The plan accent, Cursor's: amber marks anything that is about a plan (the
 * Plan pill in the composer, the plan icon, the Build button), while the
 * document itself stays neutral.
 */
export const PLAN_ACCENT_TEXT = "text-warn";

/** Amber fill with its own on-color, so the label reads in both themes. */
export const PLAN_BUILD_BUTTON =
  "bg-warn text-on-warn hover:bg-warn/90 hover:text-on-warn disabled:bg-warn disabled:text-on-warn";
